import { BsCashCoin } from "react-icons/bs";
import { BiTrendingUp, BiTrendingDown } from "react-icons/bi";
import { AiOutlineGift, AiOutlineClockCircle } from "react-icons/ai";
import CurrencyDisplay from "../Currency/CurrencyDisplay";

const SPARKLINE_PATHS = {
  active: "M0,20 C10,18 20,10 30,12 C40,14 50,6 60,8 C70,10 80,4 90,2",
  return: "M0,22 C10,20 20,14 30,10 C40,6 50,8 60,4 C70,2 80,3 90,1",
  "pending withdraw":
    "M0,10 C10,14 20,18 30,16 C40,14 50,18 60,20 C70,16 80,18 90,15",
  "referral bonus":
    "M0,18 C10,16 20,12 30,14 C40,16 50,10 60,8 C70,10 80,6 90,4",
  default: "M0,15 C10,14 20,16 30,13 C40,10 50,12 60,10 C70,8 80,10 90,8",
};

const SPARKLINE_COLORS = {
  active: "#22c55e",
  return: "#6366f1",
  "pending withdraw": "#f97316",
  "referral bonus": "#a855f7",
  default: "#9ca3af",
};

const MiniSparkline = ({ title }) => {
  const key = title?.toLowerCase();
  const path = SPARKLINE_PATHS[key] || SPARKLINE_PATHS.default;
  const color = SPARKLINE_COLORS[key] || SPARKLINE_COLORS.default;
  const gradId = `grad-${(key || "default").replace(/\s+/g, "-")}`;

  return (
    <svg
      viewBox="0 0 90 24"
      className="w-full h-8 opacity-60"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.3" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={`${path} L90,24 L0,24 Z`} fill={`url(#${gradId})`} />
      <path
        d={path}
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AccountBalanceCard = ({ title, data, referralCount, img }) => {
  const getIconByTitle = (title) => {
    switch (title?.toLowerCase()) {
      case "active":
        return <BiTrendingUp className="text-green-500" />;
      case "return":
        return <BiTrendingUp className="text-primary-500" />;
      case "pending withdraw":
        return <AiOutlineClockCircle className="text-orange-500" />;
      case "referral bonus":
        return <AiOutlineGift className="text-purple-500" />;
      default:
        return <BsCashCoin className="text-gray-500" />;
    }
  };

  const getColorByTitle = (title) => {
    switch (title?.toLowerCase()) {
      case "active":
        return "border-green-400 bg-green-50";
      case "return":
        return "border-primary-400 bg-primary-50";
      case "pending withdraw":
        return "border-orange-400 bg-orange-50";
      case "referral bonus":
        return "border-purple-400 bg-purple-50";
      default:
        return "border-gray-400 bg-gray-50";
    }
  };

  return (
    <div
      className={`relative p-4 rounded-[24px] border shadow-sm font-body overflow-hidden hover:shadow-sm transition-all duration-300 transform hover:-translate-y-1 min-h-[120px] ${!img ? getColorByTitle(title) : ""}`}
      style={
        img
          ? {
              backgroundImage: `url(${img})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }
          : {}
      }
    >
      {/* Dark overlay when img is provided */}
      {img && <div className="absolute inset-0 bg-black/55 rounded-[24px]" />}

      {/* Content sits above overlay */}
      <div className="relative z-10">
        <div className="flex items-center justify-between mb-3">
          <div
            className={`text-xs font-medium capitalize tracking-wide ${img ? "text-gray-200" : "text-gray-500"}`}
          >
            {title}
          </div>
          <div className="text-base">{getIconByTitle(title)}</div>
        </div>

        <div className="text-left">
          <div
            className={`text-2xl font-bold mb-1 ${img ? "text-white" : "text-gray-800"}`}
          >
            {referralCount ? (
              data
            ) : (
              <CurrencyDisplay usdAmount={data || 0} className="inline" />
            )}
          </div>
          <div className={`text-xs ${img ? "text-gray-300" : "text-gray-600"}`}>
            {referralCount ? "Total Referrals" : "Balance"}
          </div>
        </div>

        <div className="mt-3">
          <MiniSparkline title={title} />
        </div>
      </div>
    </div>
  );
};
